var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "main",
    },
    [
      _c(
        "el-scrollbar",
        {
          ref: "scrollbar",
          staticStyle: { height: "100%" },
          attrs: { "wrap-class": "scrollbar-wrapper" },
        },
        [
          _c("div", { staticClass: "header clearfix" }, [
            _vm.companyStatus.logoPath
              ? _c("div", { staticClass: "logo" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.companyStatus.logoPath,
                      alt: "",
                      srcset: "",
                    },
                    on: {
                      "~error": function ($event) {
                        _vm.companyStatus.logoPath = null
                      },
                    },
                  }),
                ])
              : _c(
                  "div",
                  {
                    class: ["logo2", { aliasLineHeight: _vm.aliasLineHeight }],
                    style: "background:" + _vm.backgroundColor,
                  },
                  [_vm._v(_vm._s(_vm.setLineHeight(_vm.companyStatus.alias)))]
                ),
            _c(
              "div",
              { staticClass: "hright" },
              [
                _vm.yczz
                  ? _c(
                      "div",
                      {
                        staticClass: "zd-zhongzhi",
                        on: {
                          click: function ($event) {
                            return _vm.updateTrans(_vm.componentInfo.trans)
                          },
                        },
                      },
                      [
                        _vm.componentInfo.trans
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/zhong_active.png"),
                                alt: "",
                              },
                            })
                          : _c("img", {
                              attrs: {
                                src: require("@/assets/zhong.png"),
                                alt: "",
                              },
                            }),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "h2",
                  { staticStyle: { width: "100%" } },
                  [
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "sub-title textOverflow cls001 tags",
                          staticStyle: {
                            "max-width": "421px",
                            float: "left",
                            "font-size": "16px",
                            display: "flex",
                            "align-items": "center",
                          },
                          attrs: { title: _vm.companyStatus.companyName },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "copyName",
                              on: {
                                click: function ($event) {
                                  return _vm.copyName(
                                    _vm.companyStatus.companyName
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.companyStatus.companyName || "--")
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.companyStatus.regStatus
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "box box1",
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: { size: "small", type: "theme" },
                                },
                                [_vm._v(_vm._s(_vm.companyStatus.regStatus))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _c("companyRefresh", {
                      ref: "companyRefresh",
                      attrs: {
                        companyName: _vm.companyStatus.companyName,
                        hid: _vm.companyStatus.hid,
                        disabled: false,
                      },
                      on: { update: _vm.getData, setPcinfo: _vm.setPcinfo },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "tags",
                    staticStyle: { "min-height": "24px", "margin-top": "10px" },
                  },
                  [
                    _vm.historyNameList
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item popperClass",
                            attrs: {
                              "popper-class": "tpss",
                              effect: "light",
                              placement: "bottom-start",
                            },
                          },
                          [
                            _c("el-button", [_vm._v("曾用名")]),
                            _c(
                              "div",
                              {
                                staticClass: "company-list",
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              _vm._l(
                                this.historyNameList,
                                function (item, index) {
                                  return _c("p", { key: index }, [
                                    _vm._v(_vm._s(item)),
                                  ])
                                }
                              ),
                              0
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.companyStatus.hasDouyinShop == 1
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "new-box1",
                            staticStyle: { "margin-right": "8px" },
                            attrs: { size: "small", type: "warning" },
                          },
                          [_vm._v("抖音店铺")]
                        )
                      : _vm._e(),
                    _vm.companyStatus.hasLanVipCompany == 1
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "new-box1 hasBlue",
                            staticStyle: { "margin-right": "8px" },
                            attrs: { size: "small", type: "warning" },
                          },
                          [_vm._v("蓝V企业")]
                        )
                      : _vm._e(),
                    (_vm.companyStatus || {}).contactCount
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "box new-box1",
                            attrs: { size: "small", type: "theme" },
                          },
                          [
                            _vm._v(
                              "联系方式：" +
                                _vm._s(
                                  _vm.companyStatus.contactCount.contactCount ||
                                    0
                                )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._l(_vm.companyTags, function (tag, i) {
                      return _c(
                        "el-tag",
                        {
                          key: i,
                          staticClass: "box new-box1",
                          attrs: { size: "small", type: "theme" },
                        },
                        [_vm._v(_vm._s(tag))]
                      )
                    }),
                    _vm.cxtList.length > 0
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "box new-box1",
                            attrs: { size: "small", type: "theme" },
                          },
                          [
                            _vm._v(
                              "诚信通会员 (" +
                                _vm._s(_vm.cxtList[0].tpServiceYear) +
                                "年)"
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("span", { staticClass: "span01" }, [
                        _vm._v("企业法人："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "span02" }, [
                        _vm._v(
                          _vm._s(_vm.companyStatus.legalPersonName || "--")
                        ),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("span", { staticClass: "span01" }, [
                        _vm._v("成立日期："),
                      ]),
                      _vm.companyStatus.establishTime
                        ? _c("span", { staticClass: "span02" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatTime")(
                                  _vm.companyStatus.establishTime
                                )
                              )
                            ),
                          ])
                        : _c("span", { staticClass: "span02" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatTime")(
                                  _vm.companyStatus.estiblishTime
                                )
                              )
                            ),
                          ]),
                    ]),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("span", { staticClass: "span01" }, [
                        _vm._v("注册资本："),
                      ]),
                      _vm.companyStatus.regCapital
                        ? _c("span", { staticClass: "span02" }, [
                            _vm._v(
                              _vm._s(
                                _vm.Global.formatAmount(
                                  _vm.companyStatus.regCapital
                                )
                              )
                            ),
                          ])
                        : _c("span", { staticClass: "span02" }, [
                            _vm._v(
                              _vm._s(_vm.Global.formatAmount(_vm.regCapital))
                            ),
                          ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "mt-10" },
                  [
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("span", { staticClass: "span01" }, [
                        _vm._v("企业规模："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "span02" }, [
                        _vm._v(_vm._s(_vm.staffSize)),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("span", { staticClass: "span01" }, [
                        _vm._v("参保人数："),
                      ]),
                      _c("span", { staticClass: "span02" }, [
                        _vm._v(_vm._s(_vm.companyStatus.participants || "--")),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("span", { staticClass: "span01" }, [
                        _vm._v("年营业额："),
                      ]),
                      _c("span", { staticClass: "span02" }, [
                        _vm._v(_vm._s(_vm.info.staffNumRange || "--")),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "mt-10" },
                  [
                    _c("el-col", { staticClass: "isurl" }, [
                      _c("span", { staticClass: "span01" }, [
                        _vm._v("企业网址："),
                      ]),
                      _vm.isUrls.status === "icon"
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.isUrls.string,
                                target: "_blank",
                              },
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    "popper-class": "tpss",
                                    effect: "light",
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      staticStyle: { "margin-top": "-2px" },
                                      attrs: {
                                        src: require("@/assets/gbIcon/certificate_icon.svg"),
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "company-list",
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.yearTime) + "年工商年报"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" " + _vm._s(_vm.isUrls.string) + " "),
                            ],
                            1
                          )
                        : _vm.isUrls.status === "string"
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.isUrls.string,
                                target: "_blank",
                              },
                            },
                            [_vm._v(_vm._s(_vm.isUrls.string))]
                          )
                        : _vm.isUrls.status === "array"
                        ? _c("span", { staticClass: "span02" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.showMoreA,
                                    expression: "!showMoreA",
                                  },
                                ],
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticStyle: { display: "inline-block" },
                                    attrs: {
                                      href: _vm.isUrls.array[0],
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.isUrls.array[0]))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "more",
                                    on: { click: _vm.showMore },
                                  },
                                  [_vm._v("更多>")]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showMoreA,
                                    expression: "showMoreA",
                                  },
                                ],
                                staticStyle: { display: "flex" },
                              },
                              [
                                _c(
                                  "div",
                                  _vm._l(_vm.isUrls.array, function (url, i) {
                                    return _c(
                                      "a",
                                      {
                                        key: i,
                                        attrs: { href: url, target: "_blank" },
                                      },
                                      [_vm._v(_vm._s(url))]
                                    )
                                  }),
                                  0
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "more",
                                    on: {
                                      click: function ($event) {
                                        _vm.showMoreA = false
                                      },
                                    },
                                  },
                                  [_vm._v("收起>")]
                                ),
                              ]
                            ),
                          ])
                        : _c("span", { staticClass: "span02" }, [_vm._v("--")]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "mt-10" },
                  [
                    _c("el-col", [
                      _c("span", { staticClass: "span01" }, [
                        _vm._v("所属行业："),
                      ]),
                      _c("span", { staticClass: "span02" }, [
                        _vm._v(_vm._s(_vm.companyIndustry)),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "mt-10" },
                  [
                    _c("el-col", { staticClass: "address" }, [
                      _c("span", { staticClass: "span01" }, [
                        _vm._v("注册地址："),
                      ]),
                      _c("span", {
                        staticClass: "span02",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.companyStatus.regAddress ||
                              _vm.companyStatus.regLocation ||
                              "--"
                          ),
                        },
                      }),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { staticClass: "mt-10" },
                  [
                    _c("el-col", { staticClass: "address" }, [
                      _c("span", { staticClass: "span01" }, [
                        _vm._v("经营地址："),
                      ]),
                      _c("span", {
                        staticClass: "span02",
                        domProps: {
                          innerHTML: _vm._s(_vm.companyStatus.address || "--"),
                        },
                      }),
                    ]),
                  ],
                  1
                ),
                _vm.componentInfo.companyNameEn
                  ? _c(
                      "el-row",
                      { staticClass: "mt-10" },
                      [
                        _c("el-col", { staticClass: "address" }, [
                          _c("span", { staticClass: "span01" }, [
                            _vm._v("英文名称："),
                          ]),
                          !_vm.componentInfo.aliCompanyNameUrl
                            ? _c("span", {
                                staticClass: "span02",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.componentInfo.companyNameEn
                                  ),
                                },
                              })
                            : _c(
                                "span",
                                { staticClass: "span02" },
                                [
                                  _c(
                                    "el-link",
                                    {
                                      staticStyle: { display: "inline" },
                                      attrs: {
                                        href: _vm.componentInfo
                                          .aliCompanyNameUrl,
                                        target: "_blank",
                                        underline: false,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.componentInfo.companyNameEn)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.componentInfo.gjhRecord
                  ? _c(
                      "el-row",
                      { staticClass: "mt-10" },
                      [
                        _c("el-col", { staticClass: "address" }, [
                          _c("span", { staticClass: "span01" }, [
                            _vm._v("广交会参会历史："),
                          ]),
                          _c("span", {
                            staticClass: "span02",
                            domProps: {
                              innerHTML: _vm._s(_vm.componentInfo.gjhRecord),
                            },
                          }),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { ref: "enterpriseBody", staticClass: "enterpriseBody mt-10" },
            [
              _c(
                "div",
                { ref: "tabfixed", class: ["tabfixed", { fixed: _vm.fixed }] },
                [
                  _c(
                    "el-tabs",
                    {
                      class: ["cls-tabs-navs", { newPosition: _vm.tabFlag }],
                      on: { "tab-click": _vm.handleClick },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    _vm._l(_vm.tabs, function (item, index) {
                      return _c("el-tab-pane", {
                        key: index,
                        attrs: {
                          label: item.label + " " + _vm.computedNum1(item.num),
                          name: String(index + 1),
                          disabled: !item.num,
                        },
                      })
                    }),
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "componentTags" },
                    _vm._l(_vm.componentTitles, function (item, i) {
                      return _c(
                        "el-button",
                        {
                          key: i,
                          staticClass: "mr-10 mb-10",
                          attrs: {
                            type: item.type,
                            size: "mini",
                            disabled: item.num ? false : true,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.tagsHandle(i)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(item.label + _vm.computedNum2(item.num)) +
                              " "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "tab" },
            [
              _c(
                "transition",
                { attrs: { name: "el-fade-in-linear" } },
                [
                  _vm.activeName == 1
                    ? _c("basic-msg", {
                        ref: "basicMsg",
                        attrs: {
                          tabsInfo: _vm.tabs[_vm.activeName - 1].children,
                          activeInfo: _vm.activeInfo,
                        },
                        on: {
                          setTitle: _vm.setTitles,
                          pageTurn: _vm.companyDetailBatchV2,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "el-fade-in-linear" } },
                [
                  _vm.activeName == 2
                    ? _c("development", {
                        attrs: {
                          hid: _vm.companyStatus.hid,
                          tabsInfo: _vm.tabs[_vm.activeName - 1].children,
                          activeInfo: _vm.activeInfo,
                        },
                        on: {
                          setTitle: _vm.setTitles,
                          pageTurn: _vm.companyDetailBatchV2,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "el-fade-in-linear" } },
                [
                  _vm.activeName == 3
                    ? _c("manage", {
                        attrs: {
                          tabsInfo: _vm.tabs[_vm.activeName - 1].children,
                          activeInfo: _vm.activeInfo,
                        },
                        on: {
                          setTitle: _vm.setTitles,
                          pageTurn: _vm.companyDetailBatchV2,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "el-fade-in-linear" } },
                [
                  _vm.activeName == 4
                    ? _c("business-risk", {
                        attrs: {
                          tabsInfo: _vm.tabs[_vm.activeName - 1].children,
                          activeInfo: _vm.activeInfo,
                        },
                        on: {
                          setTitle: _vm.setTitles,
                          pageTurn: _vm.companyDetailBatchV2,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "el-fade-in-linear" } },
                [
                  _vm.activeName == 5
                    ? _c("legal-risk", {
                        attrs: {
                          tabsInfo: _vm.tabs[_vm.activeName - 1].children,
                          activeInfo: _vm.activeInfo,
                        },
                        on: {
                          setTitle: _vm.setTitles,
                          pageTurn: _vm.companyDetailBatchV2,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "el-fade-in-linear" } },
                [
                  _vm.activeName == 6
                    ? _c("property", {
                        attrs: {
                          tabsInfo: _vm.tabs[_vm.activeName - 1].children,
                          activeInfo: _vm.activeInfo,
                        },
                        on: {
                          setTitle: _vm.setTitles,
                          pageTurn: _vm.companyDetailBatchV2,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }